export default function ({ store, route }) {
  if (route.name === 'sp-slug') {
    store.commit('objects/SET_SPECIAL_PROJECT', true)
  } else {
    store.commit('objects/SET_SPECIAL_PROJECT', false)
  }
  // store.dispatch('objects/setSpecialProject', true);
}
